<template>
    <view-with-bar>
        <template slot="bar">
            <view-bar>
                <h1>{{ $t("market.currencies")}}</h1>
                <view-bar-item route="/market/currencies">{{ $t("market.currencyList")}}</view-bar-item>
                <h1>{{ $t("market.marketData")}}</h1>
                <view-bar-item route="/market/exchange-rates">{{ $t("market.exchangeRates")}}</view-bar-item>
                <view-bar-item route="/market/interest-rates">{{ $t("market.interestRates")}}</view-bar-item>
                <view-bar-item route="/market/volatilities">{{ $t("market.volatilities")}}</view-bar-item>
            </view-bar>
        </template>
    </view-with-bar>
</template>

<script>
    import ViewWithBar from "../components/layout/ViewWithBar";
    import ViewBar from "../components/navigation/ViewBar";
    import ViewBarItem from "../components/navigation/ViewBarItem";
    export default {
        name: "MarketView",
        components: {ViewBarItem, ViewBar, ViewWithBar}
    }
</script>

<style scoped>

</style>